import React from "react";

const Cover = () => {
  return (
    <div className="lushhues-cover">
      <img
        src="./images/Etsy banner - 1600px x 400px.jpeg"
        alt="etsy-cover"
        style={{ maxWidth: "100%" }}
      />
    </div>
  );
};

export default Cover;
